import { includes } from 'lodash';
import { transactionCreated } from '@blockcatio/tabby-library/lib/actions/transactions';
import { TransactionStatusEnum } from '@blockcatio/tabby-library/lib/constants';

import { authorizeCatRejected, authorizeCatConfirmed } from '../actions/account';
import { authorizeTokenRejected, authorizeTokenConfirmed } from '../actions/token';
import {
  createCampaignRejected,
  cancelCampaignConfirmed,
  cancelCampaignRejected,
  cancelRewardRejected,
  cancelRewardConfirmed,
} from '../actions/campaigns';
import { redeemRewardRejected, redeemRewardConfirmed } from '../actions/redeemReward';
import {
  CAMPAIGN_CREATE_SUBMITTED,
  CAMPAIGN_CANCEL_SUBMITTED,
  TOKEN_AUTHORIZATION_SUBMITTED,
  REWARD_CANCEL_SUBMITTED,
  REWARD_REDEEM_SUBMITTED,
  CAT_AUTHORIZATION_SUBMITTED,
  TRANSACTION_RECEIPTS_FETCHED,
} from '../actionTypes';

export default () => ({ getState, dispatch }) => next => (action) => {
  next(action);
  if (
    includes(
      [
        CAMPAIGN_CREATE_SUBMITTED,
        CAMPAIGN_CANCEL_SUBMITTED,
        REWARD_CANCEL_SUBMITTED,
        REWARD_REDEEM_SUBMITTED,
        CAT_AUTHORIZATION_SUBMITTED,
        TOKEN_AUTHORIZATION_SUBMITTED,
      ],
      action.type,
    )
  ) {
    const labels = {
      CAMPAIGN_CREATE_SUBMITTED: 'Create Campaign',
      CAMPAIGN_CANCEL_SUBMITTED: 'Cancel Campaign',
      REWARD_CANCEL_SUBMITTED: 'Cancel Reward',
      REWARD_REDEEM_SUBMITTED: 'Redeem Reward',
    };
    const ids = {
      CAMPAIGN_CREATE_SUBMITTED: action.campaign ? action.campaign.id : '',
      CAMPAIGN_CANCEL_SUBMITTED: action.campaign ? action.campaign.id : '',
      REWARD_CANCEL_SUBMITTED: action.rewardKey,
      REWARD_REDEEM_SUBMITTED: action.rewardKey,
    };
    dispatch(transactionCreated(
      action.transactionHash,
      ids[action.type] || action.transactionHash,
      action.type,
      labels[action.type] || '',
    ));
  }

  // Dispatch actions based on confirmed transactions' status.
  if (action.type === TRANSACTION_RECEIPTS_FETCHED) {
    action.transactionReceipts.forEach((receipt) => {
      const { status, transactionHash } = receipt;
      const transaction = getState().transactions.localTransactions[transactionHash];

      // Respond to transactions that failed.
      if (transaction && Number(status) === TransactionStatusEnum.failed) {
        switch (transaction.actionType) {
          case CAMPAIGN_CREATE_SUBMITTED:
            dispatch(createCampaignRejected(transaction.id));
            break;

          case CAMPAIGN_CANCEL_SUBMITTED:
            dispatch(cancelCampaignRejected(transaction.id));
            break;

          case REWARD_CANCEL_SUBMITTED:
            dispatch(cancelRewardRejected(transaction.id));
            break;

          case REWARD_REDEEM_SUBMITTED:
            dispatch(redeemRewardRejected(transaction.id));
            break;

          case CAT_AUTHORIZATION_SUBMITTED:
            dispatch(authorizeCatRejected(transaction.id));
            break;

          case TOKEN_AUTHORIZATION_SUBMITTED:
            dispatch(authorizeTokenRejected(transaction.id));
            break;

          default:
          // Nothing to do.
        }
      }

      // Respond to transactions that succeeded.
      if (transaction && Number(status) === TransactionStatusEnum.succeeded) {
        switch (transaction.actionType) {
          case CAMPAIGN_CANCEL_SUBMITTED:
            dispatch(cancelCampaignConfirmed(transaction.id));
            break;

          case REWARD_CANCEL_SUBMITTED:
            dispatch(cancelRewardConfirmed(transaction.id));
            break;

          case REWARD_REDEEM_SUBMITTED:
            dispatch(redeemRewardConfirmed(transaction.id));
            break;

          case CAT_AUTHORIZATION_SUBMITTED:
            dispatch(authorizeCatConfirmed(transaction.id));
            break;

          case TOKEN_AUTHORIZATION_SUBMITTED:
            dispatch(authorizeTokenConfirmed(transaction.id));
            break;

          default:
          // Nothing to do.
        }
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/middleware/routeTransactions.js